export default __webpack_public_path__ + "favicon.3ad89540.ico";